export default "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAic3RhdGljL21lZGlhL2xvZ29fbGluZV9sb2dpbl9wYWdlLjc0MjBhYjE2LnBuZyI7"